import * as ambassadorWixPaymentsPaymentAcceptanceConfigurationsV1PaymentAcceptanceConfiguration from './payments-payment-acceptance-configurations-v1-payment-acceptance-configuration-payment-acceptance-configurations.http.js';
import * as ambassadorWixPaymentsPaymentAcceptanceConfigurationsV1PaymentAcceptanceConfigurationTypes from './payments-payment-acceptance-configurations-v1-payment-acceptance-configuration-payment-acceptance-configurations.types.js';
import * as ambassadorWixPaymentsPaymentAcceptanceConfigurationsV1PaymentAcceptanceConfigurationUniversalTypes from './payments-payment-acceptance-configurations-v1-payment-acceptance-configuration-payment-acceptance-configurations.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createPaymentAcceptanceConfiguration(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixPaymentsPaymentAcceptanceConfigurationsV1PaymentAcceptanceConfigurationUniversalTypes.CreatePaymentAcceptanceConfigurationRequest,
  ambassadorWixPaymentsPaymentAcceptanceConfigurationsV1PaymentAcceptanceConfigurationTypes.CreatePaymentAcceptanceConfigurationRequest,
  ambassadorWixPaymentsPaymentAcceptanceConfigurationsV1PaymentAcceptanceConfigurationUniversalTypes.CreatePaymentAcceptanceConfigurationResponse,
  ambassadorWixPaymentsPaymentAcceptanceConfigurationsV1PaymentAcceptanceConfigurationTypes.CreatePaymentAcceptanceConfigurationResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPaymentsPaymentAcceptanceConfigurationsV1PaymentAcceptanceConfiguration.createPaymentAcceptanceConfiguration(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/payment-acceptance-configurations',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getPaymentAcceptanceConfiguration(): __PublicMethodMetaInfo<
  'GET',
  { paymentAcceptanceConfigurationId: string },
  ambassadorWixPaymentsPaymentAcceptanceConfigurationsV1PaymentAcceptanceConfigurationUniversalTypes.GetPaymentAcceptanceConfigurationRequest,
  ambassadorWixPaymentsPaymentAcceptanceConfigurationsV1PaymentAcceptanceConfigurationTypes.GetPaymentAcceptanceConfigurationRequest,
  ambassadorWixPaymentsPaymentAcceptanceConfigurationsV1PaymentAcceptanceConfigurationUniversalTypes.GetPaymentAcceptanceConfigurationResponse,
  ambassadorWixPaymentsPaymentAcceptanceConfigurationsV1PaymentAcceptanceConfigurationTypes.GetPaymentAcceptanceConfigurationResponse
> {
  const payload = {
    paymentAcceptanceConfigurationId: ':paymentAcceptanceConfigurationId',
  } as any;

  const getRequestOptions =
    ambassadorWixPaymentsPaymentAcceptanceConfigurationsV1PaymentAcceptanceConfiguration.getPaymentAcceptanceConfiguration(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/payment-acceptance-configurations/{paymentAcceptanceConfigurationId}',
    pathParams: {
      paymentAcceptanceConfigurationId: 'paymentAcceptanceConfigurationId',
    },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updatePaymentAcceptanceConfiguration(): __PublicMethodMetaInfo<
  'PATCH',
  { paymentAcceptanceConfigurationId: string },
  ambassadorWixPaymentsPaymentAcceptanceConfigurationsV1PaymentAcceptanceConfigurationUniversalTypes.UpdatePaymentAcceptanceConfigurationRequest,
  ambassadorWixPaymentsPaymentAcceptanceConfigurationsV1PaymentAcceptanceConfigurationTypes.UpdatePaymentAcceptanceConfigurationRequest,
  ambassadorWixPaymentsPaymentAcceptanceConfigurationsV1PaymentAcceptanceConfigurationUniversalTypes.UpdatePaymentAcceptanceConfigurationResponse,
  ambassadorWixPaymentsPaymentAcceptanceConfigurationsV1PaymentAcceptanceConfigurationTypes.UpdatePaymentAcceptanceConfigurationResponse
> {
  const payload = {
    paymentAcceptanceConfiguration: { id: ':paymentAcceptanceConfigurationId' },
  } as any;

  const getRequestOptions =
    ambassadorWixPaymentsPaymentAcceptanceConfigurationsV1PaymentAcceptanceConfiguration.updatePaymentAcceptanceConfiguration(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/payment-acceptance-configurations/{paymentAcceptanceConfiguration.id}',
    pathParams: {
      paymentAcceptanceConfigurationId: 'paymentAcceptanceConfigurationId',
    },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function addPaymentAcceptanceConfigurationRules(): __PublicMethodMetaInfo<
  'POST',
  { paymentAcceptanceConfigurationId: string },
  ambassadorWixPaymentsPaymentAcceptanceConfigurationsV1PaymentAcceptanceConfigurationUniversalTypes.AddPaymentAcceptanceConfigurationRulesRequest,
  ambassadorWixPaymentsPaymentAcceptanceConfigurationsV1PaymentAcceptanceConfigurationTypes.AddPaymentAcceptanceConfigurationRulesRequest,
  ambassadorWixPaymentsPaymentAcceptanceConfigurationsV1PaymentAcceptanceConfigurationUniversalTypes.AddPaymentAcceptanceConfigurationRulesResponse,
  ambassadorWixPaymentsPaymentAcceptanceConfigurationsV1PaymentAcceptanceConfigurationTypes.AddPaymentAcceptanceConfigurationRulesResponse
> {
  const payload = {
    paymentAcceptanceConfigurationId: ':paymentAcceptanceConfigurationId',
  } as any;

  const getRequestOptions =
    ambassadorWixPaymentsPaymentAcceptanceConfigurationsV1PaymentAcceptanceConfiguration.addPaymentAcceptanceConfigurationRules(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/payment-acceptance-configurations/{paymentAcceptanceConfigurationId}/add-rules',
    pathParams: {
      paymentAcceptanceConfigurationId: 'paymentAcceptanceConfigurationId',
    },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function removePaymentAcceptanceConfigurationRules(): __PublicMethodMetaInfo<
  'POST',
  { paymentAcceptanceConfigurationId: string },
  ambassadorWixPaymentsPaymentAcceptanceConfigurationsV1PaymentAcceptanceConfigurationUniversalTypes.RemovePaymentAcceptanceConfigurationRulesRequest,
  ambassadorWixPaymentsPaymentAcceptanceConfigurationsV1PaymentAcceptanceConfigurationTypes.RemovePaymentAcceptanceConfigurationRulesRequest,
  ambassadorWixPaymentsPaymentAcceptanceConfigurationsV1PaymentAcceptanceConfigurationUniversalTypes.RemovePaymentAcceptanceConfigurationRulesResponse,
  ambassadorWixPaymentsPaymentAcceptanceConfigurationsV1PaymentAcceptanceConfigurationTypes.RemovePaymentAcceptanceConfigurationRulesResponse
> {
  const payload = {
    paymentAcceptanceConfigurationId: ':paymentAcceptanceConfigurationId',
  } as any;

  const getRequestOptions =
    ambassadorWixPaymentsPaymentAcceptanceConfigurationsV1PaymentAcceptanceConfiguration.removePaymentAcceptanceConfigurationRules(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/payment-acceptance-configurations/{paymentAcceptanceConfigurationId}/remove-rules',
    pathParams: {
      paymentAcceptanceConfigurationId: 'paymentAcceptanceConfigurationId',
    },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function modifyPaymentAcceptanceConfigurationRules(): __PublicMethodMetaInfo<
  'POST',
  { paymentAcceptanceConfigurationId: string },
  ambassadorWixPaymentsPaymentAcceptanceConfigurationsV1PaymentAcceptanceConfigurationUniversalTypes.ModifyPaymentAcceptanceConfigurationRulesRequest,
  ambassadorWixPaymentsPaymentAcceptanceConfigurationsV1PaymentAcceptanceConfigurationTypes.ModifyPaymentAcceptanceConfigurationRulesRequest,
  ambassadorWixPaymentsPaymentAcceptanceConfigurationsV1PaymentAcceptanceConfigurationUniversalTypes.ModifyPaymentAcceptanceConfigurationRulesResponse,
  ambassadorWixPaymentsPaymentAcceptanceConfigurationsV1PaymentAcceptanceConfigurationTypes.ModifyPaymentAcceptanceConfigurationRulesResponse
> {
  const payload = {
    paymentAcceptanceConfigurationId: ':paymentAcceptanceConfigurationId',
  } as any;

  const getRequestOptions =
    ambassadorWixPaymentsPaymentAcceptanceConfigurationsV1PaymentAcceptanceConfiguration.modifyPaymentAcceptanceConfigurationRules(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/payment-acceptance-configurations/{paymentAcceptanceConfigurationId}/modify-rules',
    pathParams: {
      paymentAcceptanceConfigurationId: 'paymentAcceptanceConfigurationId',
    },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deletePaymentAcceptanceConfiguration(): __PublicMethodMetaInfo<
  'DELETE',
  { paymentAcceptanceConfigurationId: string },
  ambassadorWixPaymentsPaymentAcceptanceConfigurationsV1PaymentAcceptanceConfigurationUniversalTypes.DeletePaymentAcceptanceConfigurationRequest,
  ambassadorWixPaymentsPaymentAcceptanceConfigurationsV1PaymentAcceptanceConfigurationTypes.DeletePaymentAcceptanceConfigurationRequest,
  ambassadorWixPaymentsPaymentAcceptanceConfigurationsV1PaymentAcceptanceConfigurationUniversalTypes.DeletePaymentAcceptanceConfigurationResponse,
  ambassadorWixPaymentsPaymentAcceptanceConfigurationsV1PaymentAcceptanceConfigurationTypes.DeletePaymentAcceptanceConfigurationResponse
> {
  const payload = {
    paymentAcceptanceConfigurationId: ':paymentAcceptanceConfigurationId',
  } as any;

  const getRequestOptions =
    ambassadorWixPaymentsPaymentAcceptanceConfigurationsV1PaymentAcceptanceConfiguration.deletePaymentAcceptanceConfiguration(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/payment-acceptance-configurations/{paymentAcceptanceConfigurationId}',
    pathParams: {
      paymentAcceptanceConfigurationId: 'paymentAcceptanceConfigurationId',
    },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryPaymentAcceptanceConfigurations(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixPaymentsPaymentAcceptanceConfigurationsV1PaymentAcceptanceConfigurationUniversalTypes.QueryPaymentAcceptanceConfigurationsRequest,
  ambassadorWixPaymentsPaymentAcceptanceConfigurationsV1PaymentAcceptanceConfigurationTypes.QueryPaymentAcceptanceConfigurationsRequest,
  ambassadorWixPaymentsPaymentAcceptanceConfigurationsV1PaymentAcceptanceConfigurationUniversalTypes.QueryPaymentAcceptanceConfigurationsResponse,
  ambassadorWixPaymentsPaymentAcceptanceConfigurationsV1PaymentAcceptanceConfigurationTypes.QueryPaymentAcceptanceConfigurationsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPaymentsPaymentAcceptanceConfigurationsV1PaymentAcceptanceConfiguration.queryPaymentAcceptanceConfigurations(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/payment-acceptance-configurations/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdatePaymentAcceptanceConfigurationTags(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixPaymentsPaymentAcceptanceConfigurationsV1PaymentAcceptanceConfigurationUniversalTypes.BulkUpdatePaymentAcceptanceConfigurationTagsRequest,
  ambassadorWixPaymentsPaymentAcceptanceConfigurationsV1PaymentAcceptanceConfigurationTypes.BulkUpdatePaymentAcceptanceConfigurationTagsRequest,
  ambassadorWixPaymentsPaymentAcceptanceConfigurationsV1PaymentAcceptanceConfigurationUniversalTypes.BulkUpdatePaymentAcceptanceConfigurationTagsResponse,
  ambassadorWixPaymentsPaymentAcceptanceConfigurationsV1PaymentAcceptanceConfigurationTypes.BulkUpdatePaymentAcceptanceConfigurationTagsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPaymentsPaymentAcceptanceConfigurationsV1PaymentAcceptanceConfiguration.bulkUpdatePaymentAcceptanceConfigurationTags(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/payment-acceptance-configurations/update-tags',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdatePaymentAcceptanceConfigurationTagsByFilter(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixPaymentsPaymentAcceptanceConfigurationsV1PaymentAcceptanceConfigurationUniversalTypes.BulkUpdatePaymentAcceptanceConfigurationTagsByFilterRequest,
  ambassadorWixPaymentsPaymentAcceptanceConfigurationsV1PaymentAcceptanceConfigurationTypes.BulkUpdatePaymentAcceptanceConfigurationTagsByFilterRequest,
  ambassadorWixPaymentsPaymentAcceptanceConfigurationsV1PaymentAcceptanceConfigurationUniversalTypes.BulkUpdatePaymentAcceptanceConfigurationTagsByFilterResponse,
  ambassadorWixPaymentsPaymentAcceptanceConfigurationsV1PaymentAcceptanceConfigurationTypes.BulkUpdatePaymentAcceptanceConfigurationTagsByFilterResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPaymentsPaymentAcceptanceConfigurationsV1PaymentAcceptanceConfiguration.bulkUpdatePaymentAcceptanceConfigurationTagsByFilter(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/payment-acceptance-configurations/update-tags-by-filter',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  PaymentAcceptanceConfiguration as PaymentAcceptanceConfigurationOriginal,
  PaymentAcceptanceRule as PaymentAcceptanceRuleOriginal,
  PaymentBrands as PaymentBrandsOriginal,
  Countries as CountriesOriginal,
  Currencies as CurrenciesOriginal,
  Restrictions as RestrictionsOriginal,
  RestrictionsPaymentBrandsOneOf as RestrictionsPaymentBrandsOneOfOriginal,
  RestrictionsCountriesOneOf as RestrictionsCountriesOneOfOriginal,
  RestrictionsCurrenciesOneOf as RestrictionsCurrenciesOneOfOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  Tags as TagsOriginal,
  TagList as TagListOriginal,
  CreatePaymentAcceptanceConfigurationRequest as CreatePaymentAcceptanceConfigurationRequestOriginal,
  CreatePaymentAcceptanceConfigurationResponse as CreatePaymentAcceptanceConfigurationResponseOriginal,
  GetPaymentAcceptanceConfigurationRequest as GetPaymentAcceptanceConfigurationRequestOriginal,
  GetPaymentAcceptanceConfigurationResponse as GetPaymentAcceptanceConfigurationResponseOriginal,
  UpdatePaymentAcceptanceConfigurationRequest as UpdatePaymentAcceptanceConfigurationRequestOriginal,
  UpdatePaymentAcceptanceConfigurationResponse as UpdatePaymentAcceptanceConfigurationResponseOriginal,
  AddPaymentAcceptanceConfigurationRulesRequest as AddPaymentAcceptanceConfigurationRulesRequestOriginal,
  AddPaymentAcceptanceConfigurationRulesResponse as AddPaymentAcceptanceConfigurationRulesResponseOriginal,
  RemovePaymentAcceptanceConfigurationRulesRequest as RemovePaymentAcceptanceConfigurationRulesRequestOriginal,
  RemovePaymentAcceptanceConfigurationRulesResponse as RemovePaymentAcceptanceConfigurationRulesResponseOriginal,
  ModifyPaymentAcceptanceConfigurationRulesRequest as ModifyPaymentAcceptanceConfigurationRulesRequestOriginal,
  MaskedRules as MaskedRulesOriginal,
  ModifyPaymentAcceptanceConfigurationRulesResponse as ModifyPaymentAcceptanceConfigurationRulesResponseOriginal,
  DeletePaymentAcceptanceConfigurationRequest as DeletePaymentAcceptanceConfigurationRequestOriginal,
  DeletePaymentAcceptanceConfigurationResponse as DeletePaymentAcceptanceConfigurationResponseOriginal,
  QueryPaymentAcceptanceConfigurationsRequest as QueryPaymentAcceptanceConfigurationsRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryPaymentAcceptanceConfigurationsResponse as QueryPaymentAcceptanceConfigurationsResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  BulkUpdatePaymentAcceptanceConfigurationTagsRequest as BulkUpdatePaymentAcceptanceConfigurationTagsRequestOriginal,
  BulkUpdatePaymentAcceptanceConfigurationTagsResponse as BulkUpdatePaymentAcceptanceConfigurationTagsResponseOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  BulkUpdatePaymentAcceptanceConfigurationTagsResult as BulkUpdatePaymentAcceptanceConfigurationTagsResultOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  BulkUpdatePaymentAcceptanceConfigurationTagsByFilterRequest as BulkUpdatePaymentAcceptanceConfigurationTagsByFilterRequestOriginal,
  BulkUpdatePaymentAcceptanceConfigurationTagsByFilterResponse as BulkUpdatePaymentAcceptanceConfigurationTagsByFilterResponseOriginal,
  Empty as EmptyOriginal,
  MetaSiteSpecialEvent as MetaSiteSpecialEventOriginal,
  MetaSiteSpecialEventPayloadOneOf as MetaSiteSpecialEventPayloadOneOfOriginal,
  Asset as AssetOriginal,
  State as StateOriginal,
  StateWithLiterals as StateWithLiteralsOriginal,
  SiteCreated as SiteCreatedOriginal,
  SiteCreatedContext as SiteCreatedContextOriginal,
  SiteCreatedContextWithLiterals as SiteCreatedContextWithLiteralsOriginal,
  Namespace as NamespaceOriginal,
  NamespaceWithLiterals as NamespaceWithLiteralsOriginal,
  SiteTransferred as SiteTransferredOriginal,
  SiteDeleted as SiteDeletedOriginal,
  DeleteContext as DeleteContextOriginal,
  DeleteStatus as DeleteStatusOriginal,
  DeleteStatusWithLiterals as DeleteStatusWithLiteralsOriginal,
  SiteUndeleted as SiteUndeletedOriginal,
  SitePublished as SitePublishedOriginal,
  SiteUnpublished as SiteUnpublishedOriginal,
  SiteMarkedAsTemplate as SiteMarkedAsTemplateOriginal,
  SiteMarkedAsWixSite as SiteMarkedAsWixSiteOriginal,
  ServiceProvisioned as ServiceProvisionedOriginal,
  ServiceRemoved as ServiceRemovedOriginal,
  SiteRenamed as SiteRenamedOriginal,
  SiteHardDeleted as SiteHardDeletedOriginal,
  NamespaceChanged as NamespaceChangedOriginal,
  StudioAssigned as StudioAssignedOriginal,
  StudioUnassigned as StudioUnassignedOriginal,
  SiteUrlChanged as SiteUrlChangedOriginal,
  SitePurgedExternally as SitePurgedExternallyOriginal,
  OdeditorAssigned as OdeditorAssignedOriginal,
  OdeditorUnassigned as OdeditorUnassignedOriginal,
  PicassoAssigned as PicassoAssignedOriginal,
  PicassoUnassigned as PicassoUnassignedOriginal,
  WixelAssigned as WixelAssignedOriginal,
  WixelUnassigned as WixelUnassignedOriginal,
  StudioTwoAssigned as StudioTwoAssignedOriginal,
  StudioTwoUnassigned as StudioTwoUnassignedOriginal,
  UserDomainMediaEnabled as UserDomainMediaEnabledOriginal,
  UserDomainMediaDisabled as UserDomainMediaDisabledOriginal,
  EditorlessAssigned as EditorlessAssignedOriginal,
  EditorlessUnassigned as EditorlessUnassignedOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './payments-payment-acceptance-configurations-v1-payment-acceptance-configuration-payment-acceptance-configurations.types.js';
